import { createStore } from 'vuex';
import axios from 'axios'
import { API_BASE_URL } from '../config/api'


const ax = axios.create({
  withCredentials: true,
  baseURL: API_BASE_URL,
});

// function isTokenExpired(token) {
//   const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
//   return (Math.floor((new Date).getTime() / 1000)) >= expiry;
// }
function isRefreshOk(token) {
  try {
    const tk = JSON.parse(atob(token.split('.')[1]));
    const isRef = tk.token_type == "refresh";
    const isInTime = (Math.floor((new Date).getTime() / 1000)) < tk.exp;
    return isRef && isInTime
  } catch (err) {
    return false;
  }
  
}

function getUserIdFromToken(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.user_id ?? payload.userId ?? payload.id ?? payload.sub ?? null;
  } catch (err) {
    return null;
  }
}


export default createStore({
  state: {
    authToken: localStorage.getItem('authToken') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    telefon: localStorage.getItem('telefon') || localStorage.getItem('username') || null,
    username: localStorage.getItem('username') || localStorage.getItem('telefon') || null,
    userId: localStorage.getItem('userId') || null,
    authenticated: false,
  },
  mutations: {
    setAuthToken(state, token){
      state.authToken = token
      localStorage.setItem('authToken', token)
    },
    setRefreshToken(state, token) {
      state.refreshToken = token
      localStorage.setItem('refreshToken', token)
      const userId = getUserIdFromToken(token)
      state.userId = userId
      if (userId != null) {
        localStorage.setItem('userId', userId)
      }
    },
    setTelefon(state, telefon) {
      state.telefon = telefon
      state.username = telefon
      localStorage.setItem('telefon', telefon)
      localStorage.setItem('username', telefon)
    },
    setUsername(state, username) {
      state.username = username
      state.telefon = username
      localStorage.setItem('username', username)
      localStorage.setItem('telefon', username)
    },
    clearAuthTokens(state) {
      state.authToken = null
      state.refreshToken = null
      state.telefon = null
      state.username = null
      state.userId = null
      localStorage.removeItem('authToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('telefon')
      localStorage.removeItem('username')
      localStorage.removeItem('userId')
    },
    setAuthenticated(state, payload) {
      state.authenticated = payload
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
        const formData = { username: username, password: password };
        //console.log(formData);
      const resp = await ax.post("rest_api/token/", formData);
      const { access, refresh } = await resp.data;
      
      commit('setTelefon', username)
      commit('setAuthToken', access)
      commit('setRefreshToken', refresh)
      commit('setAuthenticated', access!=null&&refresh!=null)
    },
    async rrefreshToken({ state, commit }) {
      if (!isRefreshOk(state.refreshToken)) {
        commit("clearAuthTokens", null);
        throw new Error('Sesiunea a expirat.');
      } else {
        const formData = { refresh: state.refreshToken };
        try {
          const resp = await fetch(`${API_BASE_URL}/rest_api/token/refresh/`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            });
          if (!resp.ok) throw new Error('Nu s-a putut reînnoi sesiunea.');
          const { access, refresh } = await resp.json();
          const refreshActualizat = refresh || state.refreshToken;
          if (!access || !refreshActualizat) throw new Error('Sesiunea nu a fost reînnoită.');
          commit('setAuthToken', access)
          commit('setRefreshToken', refreshActualizat)
          commit('setAuthenticated', true)
          return access;
        } catch (error) {
          commit("clearAuthTokens", null);
          throw error;
        }
      }
    },
    async logout({commit}) {
        //const formData = { uita: "dummy thing to do" };
        //const resp = ax.post("rest_api/token/refresh/", formData);
        commit("clearAuthTokens", null);
        //ax.defaults.headers["Authorization"] = `Bearer `;
     
    },
    checkAuthenticated({ commit }) {
      const token = localStorage.getItem('authToken')
      const rtoken = localStorage.getItem('refreshToken')
      if (token&&rtoken&&token.length > 20 && rtoken.length > 20) commit('setAuthenticated', true)
      else commit('setAuthenticated', false)
    }
  }
})


// import { createStore } from "vuex";
// import axios from "axios";

// const ax = axios.create({
//   withCredentials: true,
//   baseURL: "https://uti.umbgrup.ro", // #TODO old hardcoded production backend URL in commented code
// });

// export default createStore({
//   state: {
//     authenticated: false,
//     token: localStorage.getItem('intrare') ||null,
//     date: {},
//   },
//   mutations: {
//     //syncronus update
//     setAuthenticated_m(state, token) {
//       state.authenticated = token != null;
//       state.token = token;
//     },
//     setDate(state, date_noi) {
//       state.date = date_noi;
//     },
//   },
//   actions: {
//     //asyncronus
//     async setAuthenticated(state, { username, password }) {
//       try {
//         const formData = { username: username, password: password };
//         //console.log(formData);
//         const resp = await ax.post("rest_api/token/", formData);
//         const da = await resp.data;
//         const token = da.access;
//         const refresh = da.refresh;
//         state.commit("setAuthenticated_m", token);
//         localStorage.clear()
//         localStorage.setItem('intrare', token);
//         localStorage.setItem('memo', refresh);
//         ax.defaults.headers["Authorization"] = `Bearer ${token}`;
//       } catch (err) {
//         state.commit("setAuthenticated_m", null);
//       }
//     },

//     async rrefAuthenticated(state) {
//       try {
//         const formData = { refresh: "dummy thing to do" };
//         const resp = await ax.post("rest_api/token/refresh/", formData);
//         const da = await resp.data;
//         const token = da.access;
//         const refresh = da.refresh;
//         state.commit("setAuthenticated_m", token);
//         localStorage.clear();
//         localStorage.setItem('intrare', token);
//         localStorage.setItem('memo', refresh);
//         ax.defaults.headers["Authorization"] = `Bearer ${token}`;
//         setTimeout(() => this.dispatch("refAuthenticated"), 8 * 60 * 1000);
//       } catch (err) {
//         state.commit("setAuthenticated_m", null);
//       }
//     },

//     async uita(state) {
//       try {
//         const formData = { uita: "dummy thing to do" };
//         const resp = ax.post("rest_api/token/refresh/", formData);
//         console.log(resp);
//         state.commit("setAuthenticated_m", null);
//         localStorage.setItem('intrare', '');
//         localStorage.setItem('memo', '');
//         ax.defaults.headers["Authorization"] = `Bearer `;
//       } catch (err) {
//         state.commit("setAuthenticated_m", null);
//       }
//     },

//     refAuthenticated(state) {
//       const formData = { refresh: "dummy thing to do" };
//       ax.post("rest_api/token/refresh/", formData)
//         .then((resp) => {
//           const da = resp.data;
//           const token = da.access;
//           const refresh = da.refresh;
//           state.commit("setAuthenticated_m", token);
//           localStorage.clear();
//           localStorage.setItem('intrare', token);
//           localStorage.setItem('memo', refresh);
//           axios.defaults.headers["Authorization"] = `Bearer ${token}`;
//           ax.defaults.headers["Authorization"] = `Bearer ${token}`;
//           setTimeout(() => this.dispatch("refAuthenticated"), 8 * 60 * 1000);
//         })
//         .catch(() => {
//           state.commit("setAuthenticated_m", null);
//         });
//     },

//     refState(state) {
//       ax.get("rest_fc_faz_status/").then((date) => {
//         this.date = date;
//         console.log(date);
//         state.commit("setDate", date);
//       });
//     },
//   },
//   getters: {
//     getAuthenticated(state) {
//       state.dispatch("refAuthenticated");
//       return state.authenticated;
//     },
//   },
//   modules: {},
// });
